import AppStoreButtonIcon from 'assets/app-store-button.svg?react';

const AppStoreButton = () => (
  <a href={`https://apps.apple.com/us/app/${import.meta.env.VITE_APP_IOS_APPSTORE_ID}`}>
    <AppStoreButtonIcon />
  </a>
);

export default AppStoreButton;
